import { render, staticRenderFns } from "./QRemainMenuOption.vue?vue&type=template&id=025dc274"
import script from "./QRemainMenuOption.vue?vue&type=script&lang=ts"
export * from "./QRemainMenuOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports